const cartValidation = {
  form: document.getElementById("calculatorForm") as
    | HTMLInputElement
    | undefined,
  shippingError: document.getElementById("shippingError") as
    | HTMLElement
    | undefined,

  checkErorr: document.getElementById("btnError") as HTMLElement | undefined,

  checkZip: document.getElementById("checkZip") as HTMLElement | undefined,
  checkoutBtn: document.querySelectorAll(
    ".checkoutBtn",
  ) as NodeListOf<HTMLElement>,

  checkoutBtnDummy: document.querySelectorAll(
    ".checkoutBtnDummy",
  ) as NodeListOf<HTMLElement>,

  shippingZip: document.getElementById("shippingZip") as
    | HTMLElement
    | undefined,

  init() {
    this.listiners();
  },
  validate() {
    if (!this.form) return;
    const select = this.form.querySelector("select");
    if (!select?.value) {
      this.shippingError!.classList.remove("d-none");

      this.checkoutBtnDummy.forEach((btn) => {
        btn!.classList.remove("d-none");
      });
      this.checkoutBtn.forEach((btn) => {
        btn!.classList.add("d-none");
      });

      return false;
    } else {
      this.shippingError!.classList.add("d-none");

      this.checkoutBtnDummy.forEach((btn) => {
        btn!.classList.add("d-none");
      });
      this.checkoutBtn.forEach((btn) => {
        btn!.classList.remove("d-none");
      });
      return true;
    }
  },

  validateZip() {
    if (!this.shippingZip) {
      this.checkErorr!.classList.remove("d-none");
      this.checkoutBtnDummy.forEach((btn) => {
        btn!.classList.remove("d-none");
      });
      this.checkoutBtn.forEach((btn) => {
        btn!.classList.add("d-none");
      });
      return false;
    } else {
      this.checkErorr!.classList.add("d-none");

      this.checkoutBtnDummy.forEach((btn) => {
        btn!.classList.add("d-none");
      });
      this.checkoutBtn.forEach((btn) => {
        btn!.classList.remove("d-none");
      });
      return true;
    }
  },
  listiners() {
    this.checkoutBtnDummy.forEach((btn) => {
      btn.addEventListener("click", () => {
        if (!this.validate()) return;
        if (!this.validateZip()) return;
        this.checkoutBtn.forEach((btn) => {
          btn.click();
        });
      });
    });

    // this.checkoutBtnDummy?.addEventListener('click', () => {
    //   if (!this.validate()) return;
    //   this.checkoutBtn!.click();
    // });
    this.checkZip?.addEventListener("click", (e) => {
      if (!this.validate()) {
        e.preventDefault();
      }
    });
  },
};

export default cartValidation;
